// extracted by mini-css-extract-plugin
export default {"wrapper":"o_abvnsehwD4bH4YbN7c","input":"RLq6KBAiw0RUjEA5O15w"};